import clsx from 'clsx'
import NextImage from 'next/legacy/image'
import Link from 'next/link'
import type { FunctionComponent } from 'react'
import { InternalLink } from '../../const/Links'
import { Translation, useTranslate } from '../../contexts/TranslationContext'
import SvgCheck from '../../svg/icons/Check'
import { Button } from '../shared/Button'
import { Hidden } from '../shared/Hidden'
import style from './RegisterBanner.module.sass'

type RegisterBannerProps = {
	vertical?: boolean
	thin?: boolean
	isAlignedLeft?: boolean
	isAlignedRight?: boolean
}

export const RegisterBanner: FunctionComponent<RegisterBannerProps> = ({
	vertical = false,
	thin = false,
	isAlignedLeft = false,
	isAlignedRight = false,
}) => {
	const translate = useTranslate()

	const listItems = [
		translate('registerBanner.listItems.one'),
		translate('registerBanner.listItems.two'),
		translate('registerBanner.listItems.three'),
	]

	return (
		<Link
			href={InternalLink.Register}
			title={thin ? translate('registerBanner.button.register') : translate('registerBanner.button.registerForFree')}
			className={clsx(
				style.wrapper,
				vertical && style.verticalWrapper,
				thin && style.thinWrapper,
				isAlignedLeft && style.wrapperAlignedLeft,
				isAlignedRight && style.wrapperAlignedRight,
			)}
		>
			<div className={style.content}>
				<div className={clsx(style.title, thin && style.titleSmall)}>
					<Translation tr="registerBanner.title" />
				</div>
				<Hidden breakpoint="mobileDown">
					{!thin && (
						<ul className={style.list}>
							{listItems.map((listItem) => (
								<li key={listItem} className={style.listItem}>
									<span className={style.bulletIcon}>
										<SvgCheck />
									</span>
									{listItem}
								</li>
							))}
						</ul>
					)}
				</Hidden>
				{thin ? (
					<div className={style.imageThin}>
						<NextImage
							src="/images/Puppy.png"
							alt={translate('registerBanner.alt.image.first')}
							title={translate('registerBanner.alt.image.first')}
							layout="fill"
							objectFit="cover"
							sizes="270px"
						/>
					</div>
				) : (
					<div className={clsx(style.imageWrapperMobileVisible, vertical && style.imageWrapper)}>
						<div className={style.imageWrapperMobile}>
							<NextImage
								src="/images/Food.png"
								alt={translate('registerBanner.alt.image.food')}
								title={translate('registerBanner.alt.image.food')}
								width={106}
								height={57}
							/>
						</div>
						<div className={style.imageWrapperMobile}>
							<NextImage
								src="/images/Puppy.png"
								alt={translate('registerBanner.alt.image.first')}
								title={translate('registerBanner.alt.image.first')}
								width={167}
								height={166}
							/>
						</div>
					</div>
				)}
				<div className={style.buttonWrapper}>
					<Button
						label={
							thin ? (
								<Translation tr="registerBanner.button.register" />
							) : (
								<Translation tr="registerBanner.button.registerForFree" />
							)
						}
					/>
				</div>
			</div>
			<div className={clsx(style.imagesGroup, vertical && style.imagesGroupHidden)}>
				<div className={clsx(style.imageAbsolute, style.imageWrapper)}>
					<NextImage
						src="/images/Food.png"
						alt={translate('registerBanner.alt.image.food')}
						title={translate('registerBanner.alt.image.food')}
						width={182}
						height={108}
					/>
				</div>
				<div className={clsx(style.imageRelative, style.imageWrapper)}>
					<NextImage
						src="/images/Puppy.png"
						alt={translate('registerBanner.alt.image')}
						title={translate('registerBanner.alt.image')}
						width={276}
						height={260}
					/>
				</div>
			</div>
		</Link>
	)
}
